import { Eye, PaperPlaneTilt, BookmarkSimple } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui-kit/button';

type CampaignContentEditorHeaderProps = {
  title: string;
  subtitle: string;
  onPreview: () => void;
  onTestSend: () => void;
  onSaveAsTemplate: () => void;
  saveAsTemplateDisabled?: boolean;
  saveAsTemplateLabel?: string;
  backTo?: { label: string; to: string; state?: unknown };
  backAction?: { label: string; onClick: () => void };
};

/**
 * Prototype `campaign-editor.html` page head — Preview / Test send / Save as template.
 */
export const CampaignContentEditorHeader = ({
  title,
  subtitle,
  onPreview,
  onTestSend,
  onSaveAsTemplate,
  saveAsTemplateDisabled = false,
  saveAsTemplateLabel = 'Save as template',
  backTo,
  backAction,
}: CampaignContentEditorHeaderProps) => (
  <div className="flex flex-wrap items-start gap-4">
    <div className="min-w-0">
      <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
      <p className="mt-0.5 text-sm text-muted-foreground">{subtitle}</p>
    </div>
    <div className="flex-1" />
    <div className="flex flex-wrap items-center gap-2">
      <Button type="button" variant="outline" onClick={onPreview}>
        <Eye className="size-4" />
        Preview
      </Button>
      <Button type="button" variant="outline" onClick={onTestSend}>
        <PaperPlaneTilt className="size-4" />
        Test send
      </Button>
      <Button
        type="button"
        variant="outline"
        disabled={saveAsTemplateDisabled}
        onClick={onSaveAsTemplate}
      >
        <BookmarkSimple className="size-4" />
        {saveAsTemplateLabel}
      </Button>
      {backTo ? (
        <Link
          to={backTo.to}
          state={backTo.state}
          className="ml-2 text-xs font-medium text-muted-foreground hover:text-foreground"
        >
          {backTo.label}
        </Link>
      ) : null}
      {backAction ? (
        <button
          type="button"
          className="ml-2 text-xs font-medium text-muted-foreground hover:text-foreground"
          onClick={backAction.onClick}
        >
          {backAction.label}
        </button>
      ) : null}
    </div>
  </div>
);
